import React, { useState } from 'react';
import { InputAdornment } from '@material-ui/core';
import styled from 'styled-components';
import { TextField } from '@material-ui/core';
import { UseFormReturn } from 'react-hook-form';
import { ClinicProduct } from '../../../apis/clinic-products/types';
import { ClinicMasterProduct } from '../../../apis/clinic-master-products/types';

interface ClinicProductPharmacyPercentageEditorProps {
  form: UseFormReturn<ClinicProduct[]>;
  masterProductForm: UseFormReturn<ClinicMasterProduct>;
}

const ClinicProductPharmacyPercentageEditor = ({ form, masterProductForm }: ClinicProductPharmacyPercentageEditorProps) => {
  const [percentage, setPercentage] = useState<string>(() => {
    return masterProductForm.getValues()?.pharmacy_fee_percentage?.toString() ?? '';
  });

  const handlePercentageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setPercentage(value);

    const parsedValue = value ? parseFloat(value) : undefined;
    masterProductForm.setValue('pharmacy_fee_percentage', parsedValue);

    if (value && !isNaN(parseFloat(value))) {
      const percentageValue = parseFloat(value) / 100;
      const products = form.getValues();

      Object.keys(products).forEach((key) => {
        const index = parseInt(key);

        const product = products[index];
        if (product && product.clinic_price) {
          const newPharmacyFee = product.clinic_price * percentageValue;
          form.setValue(`${index}.pharmacy_fee`, parseFloat(newPharmacyFee.toFixed(2)));
        }
      });
    }
  };

  return (
    <StyledContainer>
      <StyledTextField
        label="Pharmacy Fee Percentage"
        InputProps={{
          endAdornment: <InputAdornment position="end">%</InputAdornment>,
        }}
        value={percentage}
        type="number"
        onChange={handlePercentageChange}
        inputProps={{
          min: 0,
          max: 100,
          step: 0.1
        }}
        fullWidth
      />
    </StyledContainer>
  );
};

export default ClinicProductPharmacyPercentageEditor;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  flex: 1;
`;

const StyledTextField = styled(TextField)`
  && {
    width: 100%;
  }
  && input[type='number'] {
    padding-right: 28px;
  }
  & label {
    color: #757575;
  }
  label[data-shrink="true"] {
    color: #757575;
  }
  && div::after {
    border-bottom: 2px solid #2f9d6d;
  }
`;
